import React from 'react'
import { eventKeyConstants  } from '../../utils/eventKey'

const noop = () => {}

export default function MenuItem ({
  disabled,
  children,
  style = {},
  onClick = noop
}) {
  const className=[
    'dropdown-menu-item text-no-wrap',
    disabled ? 'is-disabled' : null,
    onClick !== noop ? 'clickable' : null
  ]
  .filter(name => name)
  .join(' ')

  const handleKeyDown = (e) => {
    e.preventDefault();

    const elem = document.getElementById('menuId')
    let childItems = elem.children

    if (e.key === eventKeyConstants.ENTER || e.key === eventKeyConstants.SPACE) {
       onClick(e)
    } else if (e.key === eventKeyConstants.ARROWDOWN) {
      if (!e.target.nextSibling) {
        childItems[0].focus()
      } else {
        e.target.nextSibling.focus()
      }
    } else if (e.key === eventKeyConstants.ARROWUP) {
      if (!e.target.previousSibling) {
        childItems[childItems.length - 1].focus()
      } else {
        e.target.previousSibling.focus()
      }
    }
  }

  return (
    <div className={className} data-testid="dropdown-menu-item" onClick={onClick} style={style} role = 'menuitem'
    tabIndex = '-1' 
    onKeyDown = {(e) => handleKeyDown(e)}
    >
      { children }
    </div>
  )
}

